import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Rejects a `yyyy-MM-dd` control value that falls before `minProvider()`.
 *
 * Angular's built-in `MinValidator` binds to `input[type=number][min]` only, so a
 * `[min]` on a native date input is purely presentational: it greys days out in
 * the picker but a value below it still passes `form.valid` and can be submitted
 * (typed, pasted, or prefilled). Contract dates need the real check.
 *
 * The minimum is read through a provider because it can tighten after the
 * component's invoice call resolves; re-run `updateValueAndValidity()` on the
 * control when that happens.
 */
export function minDateValidator(minProvider: () => string | null | undefined): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const min = minProvider();
    if (!value || !min) return null;
    // Both sides are `yyyy-MM-dd`, so a lexicographic comparison is a date comparison.
    return String(value) < min ? { minDate: { min, actual: value } } : null;
  };
}
